import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import SuggestionItem from "./SuggestionItem";

const SuggestionsList = ({
  className,
  currentTerm,
  open,
  selectedIndex,
  suggestions = [],
  ...termProps
}) => {
  const componentBaseClass = "sal-suggestions-list";
  const componentClass = classnames(componentBaseClass, className);

  if (!open) {
    return null;
  }

  return (
    <ul className={componentClass}>
      {suggestions.map((term, index) => (
        <li
          key={`suggestion-${index}`}
          className={componentBaseClass + "__item"}
        >
          <SuggestionItem
            term={term}
            highlightedText={currentTerm}
            isHighlighted={index === selectedIndex}
            {...termProps}
          />
        </li>
      ))}
    </ul>
  );
};

SuggestionsList.propTypes = {
  className: PropTypes.string,
  currentTerm: PropTypes.string,
  onMouseEnterItem: PropTypes.func,
  onTermSearch: PropTypes.func,
  onTermSelect: PropTypes.func,
  open: PropTypes.bool,
  selectedIndex: PropTypes.number,
  suggestions: PropTypes.arrayOf(PropTypes.string),
};

export default SuggestionsList;
